import Default from "@layout/Default/Default";
import { Link } from "react-router-dom";

export default function Account() {
  return (
    <Default>
      <h3 className="text-white mb-4">My Account</h3>
      <div className="d-flex flex-column align-items-center gap-4">
        <Link to="/profile" className="btn btn-primary w-50">
          Profile
        </Link>
        <Link to="/subscription" className="btn btn-primary w-50">
          Subscription
        </Link>
        <Link to="/book-n-pendrive" className="btn btn-primary w-50">
          Book & Pendrive
        </Link>
        <Link to="/payments" className="btn btn-primary w-50">
          Payments
        </Link>
      </div>
    </Default>
  );
}
